var Marionette = require('backbone.marionette');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');

var CommonUtils = require('../../utils/common-utils.js');
var Constants = require('../../utils/constants');

var AddAddendumForm = Marionette.View.extend({
    template: require('../../templates/documents/add-addendum-form.html'),

    ui: {
        modal: '#add-addendum-modal',
        comment: '#comment',
        addAddendum: '#addendum-document'
    },

    events: {
        'click @ui.addAddendum': 'onAddAddendum',
        'keyup @ui.comment': 'onCommentChanged'
    },

    initialize: function (options) {
        var that = this;
        that.utils = new CommonUtils();
        that.addendum = {
            documentsId: options.docIds,
            addendumComment: ""
        };
    },

    templateContext: function () {
        var that = this;
    },

    onRender: function () {
        this.show();
    },

    onAddAddendum: function () {
        var that = this;
        that.utils.showSpinner("#add-addendum-loader");
        $.ajax({
            type: "POST",
            url: '/api/document/addendum/comment',
            data: JSON.stringify(that.addendum),
            contentType: 'application/json',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner("#add-addendum-loader");
                    that.hide();
                    $.notify({
                        message: 'Addendum added to selected documents successfully'
                    }, {
                        type: 'success',
                        z_index: 2000,
                    });
                    if (that.getOption("woResponseEvent") !== true)
                        that.triggerMethod('addendum:added:to:document');
                }
            },
            error: function (e) {
                that.utils.hideSpinner("#add-addendum-loader");
                if (e.status == 401) {
                    actionsChannel.request("redirect:to:login");
                } else {
                    notificationsChannel.request('show:notification', JSON.parse(e.responseText));
                }
            }
        });
    },

    show: function () {
        this.ui.modal.modal({backdrop: 'static', keyboard: false});
    },

    hide: function () {
        this.ui.modal.modal('hide');
    },

    onCommentChanged: function (event) {
        this.addendum.addendumComment = event.target.value;
        if (_.isEmpty(event.target.value)) {
            this.ui.addAddendum.attr('disabled', true);
        } else {
            this.ui.addAddendum.removeAttr('disabled');
        }
    }

});

module.exports = AddAddendumForm;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/add-addendum-form.js
// module id = 326
// module chunks = 0